import { render } from "./AccountNotVerifiedPage.vue?vue&type=template&id=27f0f6a6&scoped=true&ts=true"
import script from "./AccountNotVerifiedPage.vue?vue&type=script&lang=ts"
export * from "./AccountNotVerifiedPage.vue?vue&type=script&lang=ts"

import "./AccountNotVerifiedPage.vue?vue&type=style&index=0&id=27f0f6a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f0f6a6"]])

export default __exports__